/**
 * Get cart item quantity from cart fragments by cart item key
 *
 * @since 1.0.0
 */

import type { CartFragments } from '../types';

/**
 * Get cart item quantity from cart fragments by cart item key
 *
 * @param cartFragments - Cart fragments data from PHP
 * @param cartItemKey - Cart item key to look up
 * @returns The quantity of the item in cart, or null if not found
 */
export const getCartItemQuantityFromFragments = (
  cartFragments: Record<string, unknown>,
  cartItemKey: string
): number | null => {
  const typedFragments = cartFragments as CartFragments;
  const cartItems = typedFragments?.cart_items;

  if (!cartItems || !cartItemKey) {
    return null;
  }

  const cartItem = cartItems[cartItemKey];

  if (!cartItem) {
    return null;
  }

  const quantity = cartItem.quantity;
  return quantity ? parseInt(String(quantity), 10) || null : null;
};
